import React from 'react';
import './style.css';
import {ReactComponent as CloseModal } from '../../assets/modal-close.svg';
import DeleteIcon from '@mui/icons-material/Delete';

export default function DeleteProjectPopup(props) {
  //console.log(props.giveStyle);
  const marginleft=props.giveStyle ? props.giveStyle :"";
  return (
    <div className={`flex fixed top-0 h-screen w-full subscribe-modal justify-center lg:"-ml-20"}`} 
    style={{zIndex: '9', width: '96%'}} >
      <div className='self-center w-full sm:w-2/5 shadow-xl rounded-2xl shadow-box lic-text'>
        <div className='flex justify-end px-8 pt-8'>
          <CloseModal className='cursor-pointer' onClick={() => props.cancelAction()}/>
        </div>
        <div className='border-b border-gray-300 px-10 pt-2'>
          <span className='flex justify-center'>
            <DeleteIcon className='bg-gray-200 rounded-full' style={{ fontSize: "60px", color: "rgb(var(--pink))", padding: "6px"}} />
          </span>
          <h1 className='uppercase album-header py-2 flex justify-center'>{props.title}</h1>
          <p className='pt-6 pb-12 notify-text text-xs sm:text-sm flex justify-center'>
          {props.msg}
          </p>
        </div>
        <div className='w-full flex flex-wrap lg:flex-nowrap text-xs md:text-base justify-center pt-6 pb-8 px-2 gap-2'>
          <div className='lg:w-1/2 w-full text-center items-center mx-2'>
            <button 
              onClick={() => props.yesAction()} 
              className='w-full border-0 cursor-pointer' 
              style={{ fontSize: "14px", background: "rgb(var(--pink))", color: "white"}}>
             Yes, Delete
            </button>
          </div>
          <div className='lg:w-1/2 w-full text-center items-center mx-2'>
            <button 
              onClick={() => props.cancelAction()} 
              className='w-full border-0 cursor-pointer' 
              style={{ fontSize: "14px", background: "black", color: "white"}}>
              Cancel
            </button>
          </div>
          
        </div>
      </div>
    </div> 
  )
}